import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import MCSpinRecord from "integration/builders/records/mc-spin-record";
import PickMatchRecord from "slotworks/model/gameplay/records/pick-match-record";
import { HoldAndSpinRecord } from "ags/integration/records/hold-and-spin-record";

export default class CGIsRecoveryPick extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getCurrentRecord();

        const isRecovery = gameplay.isRecovered;

        const isInPickBonus = record instanceof MCSpinRecord || record instanceof HoldAndSpinRecord || record instanceof PickMatchRecord;

        return isRecovery && isInPickBonus ? Exit.True : Exit.False;
    }
}
